import { addEntry } from '../audit'

export type StorageKey = 'talks-isMuted' | 'talks-isHidden' | 'talks-features' | 'talks-rescheduled' | 'alreadySelectedAudioDevice' | 'alreadySelectedVideoDevice'

class Storage {

  private _hasStoragePermission: boolean | null = null

  constructor() {

    this._hasStoragePermission = this.checkPermission()

  }

  get hasPermission() {

    return this._hasStoragePermission

  }

  TEST_setHasPermission = (value: boolean | null) => {

    this._hasStoragePermission = value

  }

  checkPermission = () => {

    const permissionKey = 'talks-permissionCheck'
    let result

    try {

      localStorage.setItem(permissionKey, 'true')
      result = !!localStorage.getItem(permissionKey) === true
      localStorage.removeItem(permissionKey)

    }
    catch (e) {

      result = false

    }

    return result

  }

  getItem = (key: StorageKey): any | null => {

    if (!this._hasStoragePermission) return null

    const value = localStorage.getItem(key)

    if (!value) return null

    return JSON.parse(value)

  }

  setItem = (key: StorageKey, value: any): void => {

    if (!this._hasStoragePermission) return

    try {

      localStorage.setItem(key, JSON.stringify(value))

    }
    catch (e) {

      addEntry('PresenterService', 'LocalStorageSetting', `Failed to setItem: ${e}`)

    }

  }

  removeItem = (key: StorageKey): void => {

    if (!this._hasStoragePermission) return

    return localStorage.removeItem(key)

  }

}

export default new Storage()
